<template>
  <div class="readBox" :style="{backgroundImage:'url('+ bgIMG+')'}">
    <div class="PCshow">
      <div class="topBox">
        <span class="backs" @click="goback"><svg-icon icon-class="fanhui" /></span>
        <span class="names">{{ ALBUM_NAME }}</span>
      </div>
      <div class="leftBox">
        <div class="leftContent">
          <div class="mulu_box">
            <div v-for="(item,index) in mululistDate" :key="index" class="firstmulu">
              <div :class="['firstmulu_li']">
                <span class="sanjiao" @click="handelShow(item)">
                  <svg-icon v-if="!item.show" icon-class="sanjiao" />
                  <svg-icon v-else icon-class="sanjiaoxia" />
                </span>
                <span class="dian" />
                <span class="mulu_name">{{ item.CATALOG_NAME }}</span>
                <span class="num"><svg-icon icon-class="wenjian" />{{ item.CONTENT_NUMBER }}</span>
              </div>
              <div v-show="item.show">
                <div v-if="item.CONTENT_DETAIL.length>0" class="zimulu">
                  <div v-for="(item1,index2) in item.CONTENT_DETAIL" :key="index2" :class="['zimulu_li',{'avtive_li':selectId==item1.CONTENT_ID}]" @click="changeShow(item1.CONTENT_ID)">
                    <span class="zimulu_span"> {{ item1.CONTENT_TITLE }}</span>
                  <!--<span class="num"><svg-icon icon-class="wenjian" />{{ item1.CATALOG_CONTENT_SIZE }}</span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <div v-if="right_data" class="rightContent">
          <div class="topTitle">
            {{ right_data.CONTENT_TITLE }}
          </div>
          <div class="times">
            {{ right_data.CONTENT_ISSUE_DATE |changeTime }}
          </div>
          <div class="abstract">
            {{ right_data.CONTENT_ABSTRACT }}
          </div>
          <div style="text-align: center">
            <div class="imgBox">
              <img v-if="right_data.CONTENT_PHOTO_SMALL" :src="right_data.CONTENT_PHOTO_SMALL" alt="">
              <img v-else :src="noimg" alt="">
            </div>
          </div>
          <div v-if="template==='资讯'" id="tinymce" v-html="detialData.BODY_CONTENT" />
          <div v-if="template==='视频'" class="vdoBox">
            <video v-if="ismp4" :src="detialData" controls="controls" />
            <iframe v-else :src="detialData" allowfullscreen="true" frameborder="0" scrolling="no" class="iframeBox" />
          </div>
          <div v-if="template==='图集'">
            <ul ref="uls" class="uls">
              <li v-for="(item,index) in detialData" :key="index">
                <img :src="item.PHOTO_URL" alt="">
                <p>{{ item.PHOTO_DESC }}</p>
              </li>
            </ul>
          </div>
          <div v-if="template==='文库'" style="text-align: center">
            <iframe
              id="review"
              type="application/pdf"
              :src="'http://online.chinagen.cn/JointatTotemsOnline/online/onlineFile?path='+detialData"
              style="width:780px;  height:600px; margin-top:45px"
            />
          </div>
        </div>
      </div>
      <div class="pageBox">
        <div class="page_div" @click="handelShang">
          上一篇
        </div>
        <div class="page_div" @click="handelXia">
          下一篇
        </div>
        <div class="page_div" @click="goDetial">
          查看原文
        </div>
      </div>
    </div>
    <div class="PhoneShow">
      <div class="showTips">
        请在PC端查看当前页面内容
      </div>
    </div>
  </div>
</template>
<script>
import { getFirstAblumData, albumDetail, getalbumContent, getDetail } from '@/api/api.js'

export default {
  components: { },
  head() {
    var metaStr = this.right_data.CONTENT_ABSTRACT
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: this.ALBUM_NAME,
      mateDesc: metaStr,
      keys: ''
    }
  },
  data() {
    return {
      noimg: require('@/static/home_noimg.png'),
      albumId: '',
      ALBUM_NAME: '',
      mululistDate: '',
      showIndex: '',
      showIndex2: 0,
      selectId: '',
      selectDir: '',
      right_data: '',
      contentId: '',
      PREVIOUS_CONTENT_ID: '',
      NEXT_CONTENT_ID: '',
      bgIMG: require('@/static/album_bgc.png'),
      detialData: '',
      template: '',
      ismp4: true
    }
  },
  watch: {
    contentId(val) {
      getalbumContent({ albumId: this.$route.query.albumId, contentId: val }).then(res => {
        this.right_data = res.data.content[0]
        this.PREVIOUS_CONTENT_ID = res.data.ledAndLeadContentId[0].PREVIOUS_CONTENT_ID
        this.NEXT_CONTENT_ID = res.data.ledAndLeadContentId[0].NEXT_CONTENT_ID
      })
    },
    'right_data': {
      handler: function(newValue, oldValue) {
        if (newValue) {
          this.template = newValue.TEMPLATE_NAME
          getDetail({ contentId: newValue.CONTENT_ID }).then(res => {
            if (newValue.TEMPLATE_NAME === '资讯') {
              this.detialData = res.data.cmsNewsBody // /对象
            } else if (newValue.TEMPLATE_NAME === '图集') {
              this.detialData = res.data.cmsPhoto // /数组
            } else if (newValue.TEMPLATE_NAME === '视频') {
              this.detialData = res.data.cmsVideo.VIDEO_URL // /地址
              var arr = this.detialData.split('.')
              var index = arr.length - 1
              if (arr[index] != 'mp4') {
                this.ismp4 = false
              } else {
                this.ismp4 = true
              }
            } else if (newValue.TEMPLATE_NAME === '文库') {
              this.detialData = res.data.cmsDoc[0].DOC_URL // //地址
            }
          })
        }
      },
      deep: true
    }
  },

  created() {
    this.albumId = this.$route.query.albumId
    this.selectDir = this.$route.query.dirId
    albumDetail({ albumId: this.$route.query.albumId }).then(res => {
      res.data.catalogTree.forEach(a => {
        a.show = true
      })
      this.mululistDate = res.data.catalogTree
      this.ALBUM_NAME = res.data.album.ALBUM_NAME
    })
  },
  mounted() {
    this.$emit('footshow', 10)
    this.showIndex = this.$route.query.firstmuluIndex
    this.showIndex2 = this.$route.query.childmuluIndex
    this.selectId = this.$route.query.contendId
    if (!this.$route.query.contendId) {
      getFirstAblumData({ albumId: this.$route.query.albumId }).then(res => {
        this.contentId = res.data.content.CONTENT_ID
        this.right_data = res.data.content[0]
        this.PREVIOUS_CONTENT_ID = res.data.ledAndLeadContentId[0].PREVIOUS_CONTENT_ID
        this.NEXT_CONTENT_ID = res.data.ledAndLeadContentId[0].NEXT_CONTENT_ID
      })
    } else {
      this.contendId = this.$route.query.contendId
      getalbumContent({ albumId: this.$route.query.albumId, contentId: this.contendId }).then(res => {
        this.right_data = res.data.content[0]
        this.PREVIOUS_CONTENT_ID = res.data.ledAndLeadContentId[0].PREVIOUS_CONTENT_ID
        this.NEXT_CONTENT_ID = res.data.ledAndLeadContentId[0].NEXT_CONTENT_ID
      })
    }
    window.addEventListener('beforeunload', this.fn)
  },
  // asyncData({ store, route }) {
  //   return store.dispatch('albumDetail', { albumId: route.query.albumId })
  // },
  destroyed() {
    window.removeEventListener('beforeunload', this.fn)
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    handelShow: function(item) {
      if (item.show) {
        item.show = false
      } else {
        item.show = true
      }
      // this.showIndex2 = 0
      // if (index2) {
      //   this.showIndex2 = index2
      // }
    },
    changeShow: function(id) {
      this.contentId = id
      this.selectId = id
      getalbumContent({ albumId: this.albumId, contentId: id }).then(res => {
        this.right_data = res.data.content[0]
        this.PREVIOUS_CONTENT_ID = res.data.ledAndLeadContentId[0].PREVIOUS_CONTENT_ID
        this.NEXT_CONTENT_ID = res.data.ledAndLeadContentId[0].NEXT_CONTENT_ID
      })
    },
    handelShang: function() {
      if (this.PREVIOUS_CONTENT_ID !== '0') {
        this.selectId = this.PREVIOUS_CONTENT_ID
        getalbumContent({ albumId: this.albumId, contentId: this.PREVIOUS_CONTENT_ID }).then(res => {
          this.right_data = res.data.content[0]
          this.showIndex2--
          if (this.showIndex2 < 0) {
            var newindex = this.showIndex * 1 - 1
            if (newindex >= 0) {
              this.handelShow(newindex, this.mululistDate[newindex].CONTENT_NUMBER * 1 - 1)
            }
          }
          this.contentId = this.PREVIOUS_CONTENT_ID
          this.PREVIOUS_CONTENT_ID = res.data.ledAndLeadContentId[0].PREVIOUS_CONTENT_ID
          this.NEXT_CONTENT_ID = res.data.ledAndLeadContentId[0].NEXT_CONTENT_ID
        })
      } else {
        this.$message({
          message: '已经到顶部了',
          type: 'warning',
          duration: 1000
        })
      }
    },
    handelXia: function() {
      if (this.NEXT_CONTENT_ID !== '0') {
        this.selectId = this.NEXT_CONTENT_ID
        getalbumContent({ albumId: this.albumId, contentId: this.NEXT_CONTENT_ID }).then(res => {
          this.right_data = res.data.content[0]
          this.PREVIOUS_CONTENT_ID = res.data.ledAndLeadContentId[0].PREVIOUS_CONTENT_ID
          this.NEXT_CONTENT_ID = res.data.ledAndLeadContentId[0].NEXT_CONTENT_ID
          this.showIndex2 = this.showIndex2 * 1 + 1
          if (this.showIndex2 > this.mululistDate[this.showIndex].CONTENT_NUMBER * 1 - 1) {
            var newindex = this.showIndex * 1 + 1
            if (newindex <= this.mululistDate.length - 1) {
              this.handelShow(newindex)
              this.showIndex = newindex
            }
          }
        })
      } else {
        this.$message({
          message: '已经到底部了',
          type: 'warning',
          duration: 1000
        })
      }
    },
    goDetial: function() {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId: this.contentId
        }
      })
      window.open(href, '_blank')
    },
    goback: function() {
      this.$router.push({ path: '/albumDetail', query: { albumId: this.albumId }})
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .PhoneShow{
    display: none;
  }
  .uls{
    overflow: hidden;
    margin-top: 20px;
    text-align: center;
    li{
      width: 500px;
      font-size: 0;
      margin-top: 10px;
      overflow: hidden;
      display: inline-block;
      p{
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 18px;
        display: block;
      }
      img{
        width: 500px;
        height: auto;
        margin-left: 10px;
      }
    }
  }
  .vdoBox{
    margin-top: 20px;
    video{
      width: 100%;
    }
    .iframeBox{
      width: 832px;
      height:625px;
      overflow: hidden;
      overflow-x: hidden;
      overflow-y: hidden;
    }
  }
    .readBox{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 6;
        width: 100%;
        height: 100vh;
        background-color: #fff;
        overflow-y: hidden;
    }
    .topBox{
      height: 45px;
      line-height: 45px;
      width: 100%;
      background-color: #eaeaea;
      border-bottom: 1px solid #c6c6c6;
      position: absolute;
      top: 0;
      z-index:8;
      .backs{
       svg{
         &:hover{
           color: #ed4040;
         }
       }
      }
      span{
        margin-left: 15px;
        svg{
          font-size: 18px;
          font-weight: 800;
          color: #808080;
          cursor: pointer;
        }
      }
      .names{
        margin-left: 10px;
        font-size: 13px;
        color: #5b5b5b;
      }
    }
    .leftBox{
      height: 100%;
      width: 300px;
      background-color:#fff;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 7;
      .leftContent{
        margin-top: 46px;
      }
    }
    .rightBox{
      height: 100%;
      width: 835px;
      position: absolute;
      background-color:#fff;
      top: 0;
      left: 380px;
      z-index: 7;
      overflow-y:auto;
      padding-left: 40px;
      padding-right: 50px;
      .rightContent{
        margin-top: 46px;
        overflow: hidden;
        .topTitle{
          font-size: 28px;
          color: #333333;
          font-weight: 700;
          margin-top: 75px;
        }
        .times{
          font-size: 12px;
          color: #898989;
          margin-top: 15px;
        }
        .abstract{
          font-size: 14px;
          color: #4d4d4d;
          margin-top: 35px;
        }
        .imgBox{
            margin: 20px auto;
          display: inline-block;
          max-width: 800px;
          overflow: hidden;
          img{
            width: auto;
            height: 400px;
          }
        }
      }
    }
   .mulu_box{
    padding-left: 28px;
     overflow-y: auto;
     height: calc( 100vh - 100px );
     padding-bottom: 100px;
    .firstmulu{
      /*padding: 10px 0;*/
      border-bottom: 1px dashed #e6e6e6;
      .firstmulu_li{
        height: 35px;
        line-height: 35px;
      }
      .active{
        background-color: #eae8e9;
      }
      .sanjiao{
        transition: 3s;
        color: #808080;
        cursor: pointer;
        &:hover{
          color: #ed4040;
        }
      }
      .dian{
        display: inline-block;
        height: 5px;
        width: 5px;
        background-color: #59bd5b;
        margin-right: 7px;
        margin-left: 10px;
        vertical-align: middle;
      }
      .mulu_name{
        cursor: pointer;
        &:hover{
          color: #ed4040;
        }
      }
      .num{
        float: right;
        margin-right: 30px;
        color: #cdcdcd;
        width: 35px;
        text-align: right;
      }
      .zimulu{
        overflow: hidden;
        .zimulu_li{
          height: 35px;
          line-height: 35px;
          padding-left: 35px;
          border-top: 1px dashed #e6e6e6;
          cursor: pointer;
          overflow: hidden;
          &:hover{
            background-color: #eae8e9;
            color: #ed4040;
          }
          .zimulu_span{
            font-size: 13px;
            cursor: pointer;
            width: 100%;
            overflow:hidden;
            height: 35px;
            display:-webkit-box;
            -webkit-line-clamp:1;
            -webkit-box-orient:vertical;
            overflow:hidden;
            word-break: break-all;
            &:hover{
              color: #ed4040;
            }
          }
        }
        .avtive_li{
          color: #ed4040;
        }
      }
    }
  }
  .pageBox{
    height: 207px;
    width: 100px;
    position: absolute;
    left:1310px;
    top: 50%;
    z-index: 7;
    .page_div{
      width: 100px;
      background-color: red;
      margin-top: 11px;
      height: 36px;
      font-size: 13px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      &:hover{
        background-color: #333;
      }
    }
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .PCshow{
      display: none;
    }
    .PhoneShow{
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      .showTips{
        position: absolute;
        width: 80%;
        font-size: 20px;
        color: #fff;
        text-shadow: 1px 1px 1px #000,-1px -1px 1px #000;
        line-height: 48px;
        text-align: center;
        top: 50% ;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

  }
</style>
